export enum JobMode {
    Standard = 'standard',
    Email = 'email'
}

export enum TokenSub {
    Refresh = 'refresh',
    Access = 'access'
}

export enum TokenKeys {
    RefreshToken = 'pl-jwt-refresh',
    AccessToken = 'pl-jwt-access'
}

export enum JobStatus {
    Queueing = 'queueing',
    Active = 'active',
    Complete = 'complete',
    Failed = 'failed',
    Canceled = 'canceled'
}
